export class RequestError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.name = "RequestError";
    this.status = status;
  }
}
